// utils/showToast.ts
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import CustomToast from '@/components/global/CustomToast.vue';

export function showToast({
  text,
  type = 'info',
  icon,
}: {
  text: string
  type?: 'success' | 'error' | 'info' | 'default'
  icon?: any
}) {
  toast(CustomToast, {
    autoClose: true,
    hideProgressBar: true,
    position: 'bottom-right',
    type,
    data: {
      text,
      type,
      icon,
    },
  })
}
